import smartSolveApi from './instances/smartsolve';

export const getTaskStatus = async (itmId, entityName) => {
  try {
    const response = await smartSolveApi.post('/gettaskstatus', {
      itmId,
      entityName,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getTaskStatus() failed: ${e}`);
  }
};

export const getTaskCountByStatus = async (params) => {
  try {
    const response = await smartSolveApi.post('/gettaskbystatus', params);

    return response.data;
  } catch (e) {
    throw new Error(`getTaskByStatus() failed: ${e}`);
  }
};
